<template>
  <div>
    <!-- tabs栏 -->
    <div class="tabs">
      <div
        class="tabs_item"
        :class="{ activeTabs: activeTabs == index }"
        @click="changeTabs(index)"
        v-for="(item, index) in tabsList"
        :key="index"
      >
        <!-- <div class="badeg">222</div> -->
        <div>{{ item }}</div>
      </div>
      <!-- <div
        v-if="!read"
        class="read"
        :class="{ readMove: readMove }"
        @mouseenter="readMove = true"
        @mouseleave="readMove = false"
      >
        <img
          v-if="readMove"
          src="../../assets/img/personal/icon_5_10.png"
          alt=""
        />
        <img v-else src="../../assets/img/personal/icon_5_5.png" alt="" />
        <div @click="goRead">标记为已读</div>
      </div>
      <div class="read noRead" v-else>
        <img src="../../assets/img/personal/icon_5_5.png" alt="" />
        <div>已标记为已读</div>
      </div> -->
    </div>
    <!-- 系统消息 -->
    <div v-if="activeTabs == 0" class="list_box">
      <div class="list_item" v-for="(item, index) in msgList" :key="index">
        <div class="list_left" :style="{ color: read ? '#9A9A9A' : '#343434' }">
          <div
            class="list_tit"
            :class="{ readMove: readMove2 == index }"
            @mouseenter="readMove2 = index"
            @mouseleave="readMove2 = -1"
            @click="goListDetail(item.id)"
          >
            <!-- <span></span> -->
            {{ item.title }}
          </div>
          <div class="list_time">{{ item.addtime }}</div>
        </div>
        <div
          class="list_rigth"
          @mouseenter="readMove3 = index"
          @mouseleave="readMove3 = -1"
        >
          <div class="right">
            <img
              v-if="readMove3 == index"
              src="../../assets/img/personal/icon_5_7.png"
              alt=""
            />
            <!--<img v-else src="../../assets/img/personal/icon_5_6.png" alt="" />-->
            <!--<div v-if="readMove3 == index" class="delete">删除</div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- 通知公告 -->
    <div v-if="activeTabs == 1" class="list_box">
      <div class="list_item" v-for="(item, index) in msgList" :key="index">
        <div class="list_left" :style="{ color: read ? '#9A9A9A' : '#343434' }">
          <div
            class="list_tit"
            :class="{ readMove: readMove2 == index }"
            @mouseenter="readMove2 = index"
            @mouseleave="readMove2 = -1"
            @click="goListDetail(item.id)"
          >
            <!-- <span></span> -->
            <img
              v-if="read"
              src="../../assets/img/personal/icon_5_9.png"
              alt=""
            />
            <img v-else src="../../assets/img/personal/icon_5_8.png" alt="" />
            {{ item.title }}
          </div>
          <div class="list_time">{{ item.addtime }}</div>
        </div>
        <div
          class="list_rigth"
          @mouseenter="readMove3 = index"
          @mouseleave="readMove3 = -1"
        >
          <div class="right">
            <img
              v-if="readMove3 == index"
              src="../../assets/img/personal/icon_5_7.png"
              alt=""
            />
            <!--<img v-else src="../../assets/img/personal/icon_5_6.png" alt="" />-->
            <!--<div v-if="readMove3 == index" class="delete">删除</div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMsgList } from "../../assets/js/api.js";
import store from "store";
export default {
  data() {
    return {
      readMove: false,
      readMove2: -1,
      readMove3: -1,
      read: false,
      activeTabs: 0,
      tabsList: ["系统消息", "通知公告"],
      readFlag: "",
      type: 1,
      msgList: [],
    };
  },
  mounted() {
    this.activeTabs = store.get("activeTabs");
    this.type = 1;
    this.getMsgList();
  },
  methods: {
    // 获取消息列表
    getMsgList() {
        getMsgList(localStorage.getItem("siteId"), localStorage.getItem("info"), this.type).then((res) => {
          console.log(res)
        // console.log(res);
        if (res.code == 200) {
          this.msgList = res.data;
        }
      });
    },
    changeTabs(i) {
      this.activeTabs = i;
      this.type = i + 1;
      // console.log(this.type);
      store.set("activeTabs", i);
      store.set("type", this.type);
      this.getMsgList();
    },
    // 标记为已读
    goRead(i) {
      this.read = true;
    },
    goListDetail(id) {
      // id = 3;
      this.$router.push({
        path: "/msgDetail",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.readMove {
  color: #029aff !important;
}
.tabs {
  position: relative;
  width: 100%;
  height: 50px;
  border-bottom: 2px solid #029aff;
  display: flex;
  // align-items: center;
  .read {
    position: absolute;
    top: 0;
    right: 0;
    font-size: 16px;
    color: #343434;
    line-height: 50px;
    cursor: pointer;
    display: flex;
    // align-items: center;
    img {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      margin-top: 15px;
    }
  }
  .noRead {
    color: #666;
    cursor: default;
  }
  .tabs_item {
    position: relative;
    padding: 0 30px;
    box-sizing: border-box;
    height: 100%;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    font-size: 20px;
    color: #343434;
    .badeg {
      position: absolute;
      top: 5px;
      right: 10px;
      padding: 10px 8px;
      line-height: 1px;
      box-sizing: border-box;
      border-radius: 10px;
      font-size: 12px;
      background-color: #ff0001;
      color: #fff;
    }
  }
}
.list_box {
  padding-top: 30px;
  box-sizing: border-box;
  .list_item {
    height: 85px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .list_left {
      // color: #343434;
      .list_tit {
        display: flex;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        span {
          display: block;
          width: 8px;
          height: 8px;
          background: #ff0001;
          border-radius: 50%;
        }
        img {
          width: 18px;
          height: 18px;
          margin: 0 10px;
        }
      }
      .list_time {
        font-size: 14px;
        margin-top: 10px;
        margin-left: 15px;
      }
    }
    .list_rigth {
      .right {
        position: relative;
        margin-right: 30px;
        // text-align: center;
        .delete {
          position: absolute;
          top: 20px;
          right: -15px;
          width: 43px;
          height: 24px;
          line-height: 24px;
          background: #f5f5f5;
          border: 1px solid #dedede;
          border-radius: 4px;
          font-size: 12px;
          color: #343434;
          text-align: center;
          cursor: pointer;
        }
        img {
          width: 15px;
          height: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
